import React from 'react'
import { withRouter } from "react-router-dom";
import FormComponent, { FormOp, Validators } from '../../../components/form/FormOps';

class Estado extends FormComponent {

  static defaultProps = {
    onSave: () => { }
  }

  componentDidMount() {

    this.formConfig(
      { defaultUrl: 'estado/one', saveUrl: 'estado/save', backUrl: '/Catalogo/Estados' },
      FormOp.Group([
        FormOp.Field('text', 'estado', 'Estado', '', [Validators.required], 12),
        // FormOp.Field('text', 'estado_nombre', 'Estado', '', [Validators.required], 8),
      ],
        ['Guardar'], 'Estado'), this.formData)

    if (this.props.match.params.id)
      this.loadFormPreds(this.props.match.params.id)
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(Estado);